export const originFields = ["village", "ethnic_group", "clan", "region", "country"];

// Recorded lineage details take priority; missing fields use the linked parent's
// recorded origin. Never infer ethnicity from a name, birthplace or clan key.
export function lineageOrigin(recorded, parent) {
  return Object.fromEntries(originFields.map(key => [key,
    recorded?.[key]?.trim() || parent?.origin?.[key]?.trim() || "",
  ]));
}

export function hasOrigin(origin) {
  return originFields.some(key => Boolean(origin?.[key]?.trim()));
}
